import { render, staticRenderFns } from "./CourseGroups.vue?vue&type=template&id=1607b4f8&scoped=true"
import script from "./CourseGroups.vue?vue&type=script&lang=js"
export * from "./CourseGroups.vue?vue&type=script&lang=js"
import style0 from "./CourseGroups.vue?vue&type=style&index=0&id=1607b4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1607b4f8",
  null
  
)

export default component.exports